import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { customfromNow } from '@/utils';
var IntervalTime = function(props) {
    var ref = props || {}, _interval = ref.interval, interval = _interval === void 0 ? 1000 : _interval, className = ref.className, time = ref.time;
    var ref1 = useState(customfromNow(time)), content = ref1[0], setContent = ref1[1]; // useEffect(() => {
    //   const channel = new MessageChannel()
    //   let timer: NodeJS.Timeout | null = null
    //   if (channel) {
    //     channel.port1.onmessage = event => {
    //       if (timer) clearTimeout(timer)
    //       setContent(event.data)
    //       timer = setTimeout(() => {
    //         channel.port2.postMessage(customfromNow(time))
    //       }, interval)
    //     }
    //     channel.port2.postMessage(customfromNow(time))
    //   }
    //   return () => {
    //     if (timer) clearTimeout(timer)
    //   }
    // }, [])
    return(/*#__PURE__*/ _jsx("span", {
        className: className,
        children: content
    }));
};
export default IntervalTime;
